@if (filter().inputType !== 'dropdown') {
  <div>
    <mat-icon [matMenuTriggerFor]="filterOptionMenu" [svgIcon]="optionMenuIcon()"></mat-icon>
    <mat-menu class="filter-option-menu" #filterOptionMenu>
      <div class="filter-toggle" (click)="$event.stopPropagation()">
        <mat-button-toggle-group [formControl]="filterOptionControl" hideSingleSelectionIndicator>
          <mat-button-toggle class="default filter-toggle-button" value="default">
            {{ 'recordsSearch.default' | translate | uppercase }}
          </mat-button-toggle>
          <mat-button-toggle class="filter-toggle-button" value="includeEmpty">
            {{ 'recordsSearch.includeEmpty' | translate | uppercase }}
          </mat-button-toggle>
          <mat-button-toggle class="filter-toggle-button" value="excludeEmpty">
            {{ 'recordsSearch.populated' | translate | uppercase }}
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
      @if (isDateRangeFilter) {
        <!-- Date Range Title-->
        <div class="header">
          {{ 'recordsSearch.customMonthRange' | translate }}
          <mat-icon
            class="info-icon"
            svgIcon="info-icon"
            [matTooltip]="'recordsSearch.rangeNumberDate' | translate"
          ></mat-icon>
        </div>
        <!-- Date Range-->
        <div class="date-range">
          <mat-form-field (click)="$event.stopPropagation()" appearance="outline">
            <input
              matInput
              miqOnlyNumbers
              type="number"
              class="hidden-arrows"
              [placeholder]="'recordsSearch.from' | translate"
              [allowedKeyCodes]="allowedKeyCodes"
              [restrictedKeyCodes]="restrictedKeyCodes"
              [formControl]="fromRange"
              (keydown.tab)="$event.stopPropagation()"
              (click)="$event.stopPropagation()"
              />
            </mat-form-field>
            <mat-form-field (click)="$event.stopPropagation()" appearance="outline">
              <input
                matInput
                miqOnlyNumbers
                type="number"
                class="hidden-arrows"
                [placeholder]="'recordsSearch.to' | translate"
                [allowedKeyCodes]="allowedKeyCodes"
                [restrictedKeyCodes]="restrictedKeyCodes"
                [formControl]="toRange"
                (keydown.tab)="$event.stopPropagation()"
                (click)="$event.stopPropagation()"
                />
              </mat-form-field>
              <button (click)="setNumberRangeFilter()">
                <mat-icon svgIcon="done"></mat-icon>
              </button>
            </div>
            <hr />
            <!-- Options Range-->
            @for (dateFilter of dateFilterOptions; track dateFilter) {
              <button [disabled]="disableDateFilter" mat-menu-item>
                <div (click)="setDateRangeFilter(dateFilter)">{{ dateFilter.label | translate }}</div>
              </button>
            }
          }
        </mat-menu>
      </div>
    }
